<template>
  <el-form
    :model="loginForm"
    ref="loginForm"
    label-width="0px"
    class="login"
    @keyup.enter.native="doLogin('loginForm')"
  >
    <el-form-item
      prop="userName"
      :rules="[{ required: true, message: '请输入账号' }]"
    >
      <el-input
        type="text"
        v-model="loginForm.userName"
        autocomplete="off"
        prefix-icon="el-icon-user-solid"
        placeholder="请输入账号"
      ></el-input>
    </el-form-item>

    <el-form-item
      prop="password"
      :rules="[{ required: true, message: '请输入密码' }]"
    >
      <el-input
        type="password"
        v-model="loginForm.password"
        autocomplete="off"
        prefix-icon="el-icon-lock"
        placeholder="请输入密码"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <el-button
        :loading="loading"
        round
        type="primary"
        @click="doLogin('loginForm')"
        style="width: 100%; font-size: 18px"
        >登录</el-button
      >
    </el-form-item>
  </el-form>
</template>
<script>
import axios from "axios";
import { Button, Form, FormItem, Input, Message } from "element-ui";
import ElRow from "element-ui/packages/row/src/row";
import { Base64 } from "js-base64";
export default {
  components: { ElRow },
  beforeCreate() {
    // this.form = this.$form.createForm(this);
  },
  data() {
    return {
      loginForm: {
        userName: "",
        password: "",
        // imagecode: "",
      },
      loading: false,
      error: "",
      codeImg: undefined
    };
  },
  created() {
    // this.getCaptcha();
    this.$router.options.routes = [];
  },
  methods: {
    doLogin(loginForm) {
      // 用户名密码登录
      this.$refs[loginForm].validate((valid) => {
        if (valid) {
          this.loading = true;
          let loginInfo = { ...this.loginForm };
          loginInfo.password = Base64.encode(loginInfo.password);
          this.axios.post('api/user-info/login', loginInfo, {headers: {'Content-Type': 'application/json'}}).then((r) => {
            this.saveLoginData(r);
            setTimeout(() => {
              this.loading = false;
            }, 500)

          }).catch((e) => {
            console.error(e)
            setTimeout(() => {
              this.loading = false;
            }, 500)
          })
        } else {
          return false;
        }
      });
    },
    regist() {
      this.$emit('regist', 'Regist')
    },
    saveLoginData(r) {
      let code = r.data.code;
      let msg = r.data.msg;
      //判断登录之后返回的信息
      if (code != 200) {
        this.$message({
          message: msg,
          type: "error",
          center: true,
        });
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        var userInfo = r.data.data;
        var sessionId = r.headers.sessionid;
        sessionStorage.setItem('user', JSON.stringify(userInfo));
        sessionStorage.setItem('sessionId', sessionId);
        this.$message({
          message: "欢迎用户" + userInfo.userName + "  登录成功！",
          type: "success",
          center: true,
        });
        this.$router.push("/index");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  /deep/ .el-input__inner {
    border-radius: 30px;
  }
  /deep/ &:hover {
    color: #1890ff;
  }
  img {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
}
</style>
